import React from 'react';
import DocumentosKpisBar from '../../../components/shared/DocumentosKpisBar';

export type PedidosKpisBarProps = {
  cantidadPedidos: number;
  precioTotal: number;
  precioNeto: number;
  pesoTotalKg: number;
  volumenTotalM3: number;
};

const PedidosKpisBar: React.FC<PedidosKpisBarProps> = ({
  cantidadPedidos,
  precioTotal,
  precioNeto,
  pesoTotalKg,
  volumenTotalM3,
}) => (
  <DocumentosKpisBar
    cantidad={cantidadPedidos}
    cantidadLabel="pedidos"
    precioTotal={precioTotal}
    precioNeto={precioNeto}
    pesoTotalKg={pesoTotalKg}
    volumenTotalM3={volumenTotalM3}
    ariaLabel="Resumen de pedidos"
  />
);

export default PedidosKpisBar;
